import { AsyncPipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '@shared/services/loading.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, AsyncPipe],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('fe-website');
  private translate = inject(TranslateService);
  private loadingService = inject(LoadingService);
  loading$ = this.loadingService.loading$;
  

  constructor() {
    this.translate.addLangs(['it', 'en']);
    this.translate.setFallbackLang('it');
    this.translate.use('it');
  }

  switchLang(lang: string) {
    this.translate.use(lang);
  }

  onSubmit(): void {
    console.log('Bottone cliccato!');
  }
}